export default __webpack_public_path__ + "static/media/guestbook.9506a21f.svg";